import React from 'react';
import Icon from '../../../components/AppIcon';

const TrendingContentCard = ({ content }) => {
  return (
    <div className="p-4 rounded-xl bg-card border border-border hover:shadow-warm transition-base">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <Icon name="TrendingUp" size={16} className="text-success" />
          <h4 className="text-sm md:text-base font-semibold text-foreground">{content?.name}</h4>
        </div>
        <span className="text-xs font-medium text-success">+{content?.trend}%</span>
      </div>
      <div className="space-y-2">
        <div className="flex items-center justify-between text-xs md:text-sm">
          <span className="text-muted-foreground">Completions</span>
          <span className="font-semibold text-foreground">{content?.completions}/{content?.total}</span>
        </div>
        <div className="character-progress h-2">
          <div 
            className="character-progress-bar" 
            style={{ width: `${(content?.completions / content?.total) * 100}%` }}
          />
        </div>
      </div>
      <div className="flex items-center gap-4 mt-3 pt-3 border-t border-border">
        <div className="flex items-center gap-1">
          <Icon name="Users" size={14} className="text-muted-foreground" />
          <span className="text-xs text-muted-foreground">{content?.activeMembers} active</span>
        </div>
        <div className="flex items-center gap-1">
          <Icon name="Clock" size={14} className="text-muted-foreground" />
          <span className="text-xs text-muted-foreground">{content?.avgTime}</span>
        </div>
      </div>
    </div>
  );
};

export default TrendingContentCard;